<template>
  <keep-alive><div class="Step4Container">
    <div class="mainContainer">
      <img class="imgSuccess" src="@/assets/img/weitu.png" alt="">
      <!-- <div class="msgOfSuccess">提交成功</div> -->
      <!-- <div class="tipMsg">请等待公安机关审批，可登录系统查看审批结果。</div> -->
      <div class="msgOfSuccess">已完成</div>
      <div class="tipMsg">贵单位注册信息申请提交完成，等待公安审批。</div>
      <el-button v-preventReClick style="background-color: #4170ff; color: white;margin-top:50px" @click="back">返回登录</el-button>
    </div>
  </div></keep-alive>

</template>

<script>
import { removeToken } from '@/utils/tool'

export default {
  name: 'Step6',
  props: {
    step: Number
  },
  data() {
    return {

    }
  },
  methods: {
    back() {
      removeToken()
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="less" scoped>
.Step4Container {
  width: 100%;
  background-color: #fff;
  .mainContainer {
    width: 400px;
    // height: 400px;
    // border: 1px solid red;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 86px 0;
    // position: relative;
    text-align: center;
    .imgSuccess {
      width: 128px;
      height: 128px;
      margin-bottom: 20px;
    }
    .msgOfSuccess{
      // width: 72px;
      height: 25px;
      font-size: 18px;
      line-height: 25px;
      text-align: center;
      margin-bottom: 20px;
      // position: absolute;
      // top: 234px;
      // left: 50%;
      // transform: translateX(-50%);
      font-weight: 700;
    }
    .tipMsg{
      width: 400px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      // position: absolute;
      // top: 279px;
      // left: 50%;
      // transform: translateX(-50%);
      font-family: 'PingFangSC-Regular, PingFang SC';
      color: #8B8B8B ;
      font-size: 14px;
    }
  }
}
</style>
